export const ActionType = {
  GENERATE_SHARE_LINK_STARTED: 'GENERATE_SHARE_LINK_STARTED',
  GENERATE_SHARE_LINK_FINISHED: 'GENERATE_SHARE_LINK_FINISHED',
  VALIDATE_SHARE_LINK_STARTED: 'VALIDATE_SHARE_LINK_STARTED',
  VALIDATE_SHARE_LINK_FINISHED: 'VALIDATE_SHARE_LINK_FINISHED',
};
export const RequestType = {};
